import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { isType } from './isType'

export const isPurchaseActionTreeRight = (
  action?: WpsRuntime.atv.wps.PurchaseActionTreeModelProps
): action is WpsRuntime.atv.wps.PurchaseActionTreeRightProps =>
  isType(action, 'atv.wps#PurchaseActionTreeRight')

export const isSubscribeActionTreeLeft = (
  action?: WpsRuntime.atv.wps.SubscribeActionTreeModelProps
): action is WpsRuntime.atv.wps.SubscribeActionTreeLeftProps =>
  isType(action, 'atv.wps#SubscribeActionTreeLeft')

export const isSubscribeActionTreeRight = (
  action?: WpsRuntime.atv.wps.SubscribeActionTreeModelProps
): action is WpsRuntime.atv.wps.SubscribeActionTreeRightProps =>
  isType(action, 'atv.wps#SubscribeActionTreeRight')

export const isAcquisitionActionTreeLeft = (
  action?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
): action is WpsRuntime.atv.wps.AcquisitionActionTreeLeftProps =>
  isType(action, 'atv.wps#AcquisitionActionTreeLeft')

export const isAcquisitionActionTreeRight = (
  action?: WpsRuntime.atv.wps.AcquisitionActionTreeModelProps
): action is WpsRuntime.atv.wps.AcquisitionActionTreeRightProps =>
  isType(action, 'atv.wps#AcquisitionActionTreeRight')

export const isPurchaseAction = (
  action?: WpsRuntime.atv.wps.AcquisitionActionProps
): action is WpsRuntime.atv.wps.PurchaseActionProps =>
  isType(action, 'atv.wps#TvodAction')

export const isPreorderAction = (
  action?: WpsRuntime.atv.wps.AcquisitionActionProps
): action is WpsRuntime.atv.wps.PreorderActionProps =>
  isType(action, 'atv.wps#PreorderAction')

export const isTvodAction = (
  action?: WpsRuntime.atv.wps.AcquisitionActionProps
): action is WpsRuntime.atv.wps.PurchaseActionProps | WpsRuntime.atv.wps.PreorderActionProps =>
  isPurchaseAction(action) || isPreorderAction(action)

export const isSubscribeAction = (
  action?: WpsRuntime.atv.wps.AcquisitionActionProps
): action is WpsRuntime.atv.wps.SubscribeActionProps =>
  isType(action, 'atv.wps#SubscribeAction')
  || Boolean(action && (action as WpsRuntime.atv.wps.SubscribeActionProps).sType === 'SUBSCRIPTION')
